import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetRunDriverLocationsSubscriptionVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
}>;


export type GetRunDriverLocationsSubscription = { __typename?: 'subscription_root', driverlocations: Array<{ __typename?: 'driverlocations', id: string, location: object, time: string, speed?: number | null, heading?: number | null }> };


export const GetRunDriverLocationsDocument = gql`
    subscription getRunDriverLocations($runId: bigint!) {
  driverlocations(
    where: {run_id: {_eq: $runId}}
    order_by: {time: asc}
    limit: 5000
  ) {
    id
    location
    time
    speed
    heading
  }
}
    `;

/**
 * __useGetRunDriverLocationsSubscription__
 *
 * To run a query within a React component, call `useGetRunDriverLocationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetRunDriverLocationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRunDriverLocationsSubscription({
 *   variables: {
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetRunDriverLocationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetRunDriverLocationsSubscription, GetRunDriverLocationsSubscriptionVariables> & ({ variables: GetRunDriverLocationsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetRunDriverLocationsSubscription, GetRunDriverLocationsSubscriptionVariables>(GetRunDriverLocationsDocument, options);
      }
export type GetRunDriverLocationsSubscriptionHookResult = ReturnType<typeof useGetRunDriverLocationsSubscription>;
export type GetRunDriverLocationsSubscriptionResult = Apollo.SubscriptionResult<GetRunDriverLocationsSubscription>;